import { render } from "./TO2Exercise.vue?vue&type=template&id=573c9f6c&scoped=true"
import script from "./TO2Exercise.vue?vue&type=script&lang=js"
export * from "./TO2Exercise.vue?vue&type=script&lang=js"

import "./TO2Exercise.vue?vue&type=style&index=0&id=573c9f6c&lang=scss&scoped=true"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573c9f6c"]])

export default __exports__